import template from './fleets.html';
import controller from './fleets.controller';

const fleetsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};
export default fleetsComponent;
